export enum RemittanceFeeMode {
  OUR = 'OUR', // 不內扣
  BEN = 'BEN', // 內扣
}
